(function () {
  function normalizeText(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .replace(/[_-]+/g, ' ')
      .replace(/\b(img|image|photo|picture|banner)\b/gi, '')
      .trim();
  }

  function fromFilename(src) {
    if (!src) return '';

    try {
      var url = new URL(src, window.location.origin);
      var file = url.pathname.split('/').pop() || '';
      file = file.replace(/\.[a-z0-9]+$/i, '');
      file = file.replace(/_\d+x\d+$/i, '');
      return normalizeText(decodeURIComponent(file));
    } catch (e) {
      return '';
    }
  }

  function firstText(selectors, root) {
    if (!root) return '';

    for (var i = 0; i < selectors.length; i += 1) {
      var el = root.querySelector(selectors[i]);
      var text = normalizeText(el && (el.textContent || el.innerText));
      if (text) return text;
    }

    return '';
  }

  function deriveAlt(img) {
    var direct =
      img.getAttribute('data-alt') ||
      img.getAttribute('data-image-alt') ||
      img.getAttribute('aria-label') ||
      img.getAttribute('title');
    direct = normalizeText(direct);
    if (direct) return direct;

    var labelledParent = img.closest('[aria-label]');
    var labelledText = normalizeText(labelledParent && labelledParent.getAttribute('aria-label'));
    if (labelledText) return labelledText;

    var figure = img.closest('figure');
    var figureText = normalizeText(figure && figure.querySelector('figcaption') && figure.querySelector('figcaption').textContent);
    if (figureText) return figureText;

    var contentRoot =
      img.closest('.product-card, .grid-product, .card-wrapper, .product-container, .article-card, .banner, .image-with-text, .tab_prod_container, .single_case, .rooster_box, .logos') ||
      img.closest('section, article, li, a, div');

    var semanticText = firstText(
      [
        '.product-title',
        '.card__heading',
        '.article-card__title',
        '.title',
        '.h0',
        '.h1',
        '.h2',
        '.h3',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'figcaption',
        'p',
        'span'
      ],
      contentRoot
    );
    if (semanticText) return semanticText;

    return fromFilename(img.currentSrc || img.src);
  }

  function shouldSkip(img) {
    if (!img || img.dataset.rrgAltChecked === 'true') return true;
    if (img.tagName !== 'IMG') return true;
    if ((img.getAttribute('alt') || '').trim() !== '') return true;
    if (img.getAttribute('role') === 'presentation' || img.getAttribute('role') === 'none') return true;
    if (img.getAttribute('aria-hidden') === 'true') return true;
    return false;
  }

  function applyAlt(img) {
    if (shouldSkip(img)) return;

    var fallback = deriveAlt(img);
    if (fallback) {
      img.setAttribute('alt', fallback.slice(0, 125));
      img.setAttribute('data-rrg-alt-fallback', 'true');
    }

    img.dataset.rrgAltChecked = 'true';
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.tagName === 'IMG') {
      applyAlt(scope);
      return;
    }

    var imgs = scope.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i += 1) {
      applyAlt(imgs[i]);
    }
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i += 1) {
      var mutation = mutations[i];
      for (var j = 0; j < mutation.addedNodes.length; j += 1) {
        var node = mutation.addedNodes[j];
        if (node.nodeType !== 1) continue;
        scan(node);
      }
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    }, { once: true });
  } else {
    scan(document);
  }

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
